import Kernel from './Kernel';
import FullscreenPopup from './FullscreenPopup';

export class Popup extends Kernel {
    constructor (target) {
        console.log('Module: Popup has been loaded');

        super(target);

        this.data = target.data;
        this.init();
    }

    init () {
        this.$el.on('click', (e) => {
            e.preventDefault();

            const popup = new FullscreenPopup(this.data);
            popup.initialize();

        });
    }
}

export default Popup;



// WEBPACK FOOTER //
// ./app/src/js/modules/Popup.js